<template lang="html">
  <el-card shadow="always" body-style="padding:0px;width:100%;">
    <div :id="params.id" :style="params.chartHeight"></div>
    <div :id="params.id + '_table'" class="echart_table">
      <div style="width: 100%; height: 34px; line-height: 34px">
        <div style="width: 60px; float: left; text-align: center">
          <i @click="downloadData(params.id)" class="fa fa-download searchFilerCls" aria-hidden="true" title="导出"></i>
        </div>
        <el-row :gutter="15" style="width: calc(100% - 60px); float: left">
          <el-col
            v-for="(key, index) in Object.keys(params.columnMap[params.id])"
            :key="key"
            :span="Object.keys(params.columnMap[params.id]).length <= 4 ? 6 : 4">
            <el-input
              v-model="queryFilter[key]"
              clearable
              size="mini"
              :placeholder="'请输入' + params.columnMap[params.id][key]"
              style="margin-top: 0px; margin-bottom: 3px"
              class="searchInput">
              <el-button @click="searchData(params.id)" slot="append" size="mini" icon="el-icon-search"></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <table
        :id="params.id + '_tab'"
        style="width: 100%"
        class="tabletemp table-striped table-bordered tabletemp-hover">
        <thead>
          <tr>
            <th>
              <div title="返回" class="th-inner" style="text-align: center" @click="backEcharts(params.id)">
                <i class="fa fa-mail-reply" style="font-size: 16px; color: #55d3d3"></i>
              </div>
              <div class="fht-cell"></div>
            </th>
            <th v-for="(key, index) in Object.keys(params.columnMap[params.id])" :key="key" nowrap="nowrap">
              <div class="th-inner text-warning">
                {{ params.columnMap[params.id][key] }}
                <i
                  @click="sortData(params.id, key, querySort[params.id][key])"
                  :class="
                    querySort[params.id][key] == 'sort'
                      ? 'fa fa-sort'
                      : querySort[params.id][key] == 'asc'
                      ? 'fa fa-sort-asc'
                      : querySort[params.id][key] == 'desc'
                      ? 'fa fa-sort-desc'
                      : ''
                  "
                  :style="querySort[params.id][key] == 'sort' ? 'color: #e3dfdfff' : ''"></i>
                <!--                <i-->
                <!--                    v-if="index == Object.keys(params.columnMap[params.id]).length - 1"-->
                <!--                    @click="setQueryVisible(params.id)"-->
                <!--                    class="fa fa-filter searchFilerCls"-->
                <!--                    aria-hidden="true"-->
                <!--                    title="筛选" />-->
                <!--                <i-->
                <!--                    v-if="index == Object.keys(params.columnMap[params.id]).length - 1"-->
                <!--                    @click="downloadData(params.id)"-->
                <!--                    class="fa fa-download searchFilerCls"-->
                <!--                    aria-hidden="true"-->
                <!--                    title="导出" />-->
              </div>
              <div class="fht-cell">
                <el-input
                  v-if="queryVisible[params.id]"
                  v-model="queryFilter[key]"
                  clearable
                  size="mini"
                  placeholder="请输入内容"
                  class="searchInput">
                  <el-button @click="searchData(params.id)" slot="append" size="mini" icon="el-icon-search"></el-button>
                </el-input>
              </div>
            </th>
          </tr>
        </thead>
        <tbody :id="params.id + '_html'" style="font-size: 14px !important">
          <tr>
            <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-card>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");
import vintage from "echarts/theme/vintage.js";
import macarons from "echarts/theme/macarons.js";
import macarons2 from "echarts/theme/macarons2.js";
import blue from "echarts/theme/blue.js";
import cool from "echarts/theme/cool.js";
import forest from "echarts/theme/forest.js";
import fruit from "echarts/theme/fruit.js";
import green from "echarts/theme/green.js";
import roma from "echarts/theme/roma.js";
import shine from "echarts/theme/shine.js";
import london from "echarts/theme/london.js";
import infographic from "echarts/theme/infographic.js";
import chartFinance from "@/components/ChartFinance/StatisticalFinance.vue";
import provinceFinance from "@/components/ChartFinance/ProvinceFinance.vue";

import { listData } from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  props: [
    "params",
    "searchData",
    "queryFilter",
    "queryVisible",
    "querySort",
    "sortData",
    "downloadData",
    "chartResize",
    "backEcharts",
    "setDisplayVisible",
    "createDataHtml",
    "setQueryVisible",
    "listTableData",
  ],
  data() {
    return {};
  },
  methods: {
    //饼图-圆环
    chart_1(id, data) {
      let that = this;
      this.disposeChart(id);
      let nameVal = {};
      let total = 0;
      for (var index in data.data) {
        var item = data.data[index];
        nameVal[item.name] = item.value;
        total += Number(item.value);
      }
      var myChart = echarts.init(document.getElementById(id), this.params.chartTheme);
      var option = {
        title: {
          text: data.title,
          subtext: "共计数量：" + total,
          left: "center",
          top: 40,
        },
        grid: {
          top: 80,
          bottom: 60,
          left: 80,
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: true},
            myTool1: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "数据列表", // 鼠标移动上去显示的文字
              icon: that.params.imgUrldata, // 图标
              option: {},
              onclick: function (option1) {
                // 点击事件,这里的option1是chart的option信息
                that.listTableData(id, myChart, option1);
              },
            },
            myTool2: {
              // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
              show: true, // 是否显示
              title: "放大显示", // 鼠标移动上去显示的文字
              icon: that.params.imgUrlfdj, // 图标
              option: {},
              onclick: function (option1) {
                that.listTableData(id, null, option);
              },
            },
            saveAsImage: { show: true, icon: that.params.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: id == "chart_35" ? 10 : 40,
          itemGap: (data.data || []).length < 5 ? 30 : 10,
          // itemWidth: 10,  // 设置宽度
          // itemHeight: 10, // 设置高度
          formatter: function (name) {
            return name; //+ "  " + nameVal[name];
          },
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "50%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              formatter(param) {
                return param.name + " " + param.value + "（" + param.percent + "%）";
              },
            },
            labelLine: {
              length: 8,
              length2: 8,
              maxSurfaceAngle: 80,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: "bold",
              },
            },
            //color:['#4FA1F3','#C976F4'],
            data: data.data,
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("===", params);
        that.listTableData(id, myChart, option, { name: params.name });
      });
      this.chartResize(myChart);
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
  },
  mounted() {
    this.chart_1(this.params.id, this.params.data[this.params.id] || []);
  },
  created: function () {},
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;
}
.echart_table {
  height: 420px;
  width: 100%;
  overflow: hidden;
  display: none;
}
.el-checkbox + .el-checkbox {
  margin-left: 15px;
}
.el-checkbox__label {
  padding-left: 4px !important;
}

.searchInput {
  margin-top: 6px;
}

.searchInputN {
  margin-top: 6px;
}

.searchFilerCls {
  color: #ff9800 !important;
}

.searchFilerClsN {
  float: right;
  padding-top: 3px;
}

.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.text-introduce {
  padding: 20px 24px 24px 30px;
}

.numStyle {
  color: red;
  font-weight: bold;
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// PieChart.vue?6453b878